import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { CommercialAgreement } from 'src/app/app-sync.service';
import { appConstants } from 'src/app/shared/constants/constants';
import { ModalsService } from 'src/app/shared/modals/modals.service';
import { CommercialAgreementsService } from './commercial-agreements.service';
import { MasterService } from '../master/master.service';
import { FormArray, FormBuilder, FormGroup } from '@angular/forms';
import { UsersService } from '../users/users.service';
import { CurrencyPipe } from '@angular/common';
import { NgbOffcanvas, NgbOffcanvasRef } from '@ng-bootstrap/ng-bootstrap';
import { FeedbacksService } from 'src/app/shared/feedbacks/feedbacks.service';
import { ApiRequestsService } from 'src/app/shared/services/api-requests.service';
import { CommercialAgreementFileParams } from 'src/app/shared/interfaces/commercial-agreements-parameters';

@Component({
  selector: 'app-commercial-agreements',
  templateUrl: './commercial-agreements.component.html',
  styleUrls: ['./commercial-agreements.component.css'],
})
export class CommercialAgreementsComponent implements OnInit {
  dtOptions: DataTables.Settings = {};
  commercialAgreements: CommercialAgreement[] = [];
  selectedAgreements: CommercialAgreement[] = [];
  commercialFormGroup: FormGroup;
  master: any = {};
  masterDisplayMap: any = {};
  isGettingAgreements: boolean = false;
  @ViewChild('uploadModal', { static: false }) uploadModal:
    | TemplateRef<any>
    | undefined;
  @ViewChild('updateListModal', { static: false }) updateListModal:
    | TemplateRef<any>
    | undefined;
  @ViewChild('createModal', { static: false }) createModal:
    | TemplateRef<any>
    | undefined;
  action: 'reject' | 'aproveN1' | 'aproveN2' | 'cancel' = 'aproveN1';
  filterForm: FormGroup;
  CENTERS: any = [];
  CARRIERS: any[] = [];
  STATUSES: any[] = [];
  CARRIERSINDEX: any;
  fromExistingAc: CommercialAgreement | undefined;
  private offcanvasRef: NgbOffcanvasRef | null = null;
  offCanvasAc: CommercialAgreement | null = null;
  historyFormatArray: {
    updatedBy: string;
    comment: string;
    updatedAt: string;
    status: string;
  }[] = [];
  pageSize: number = 10;
  total: number = 0;
  page: number = 1;
  ACToView: any[] = [];
  firstItemIndex: number = 0;
  lastItemIndex: number = 0;
  sortColumn: string = '';
  sortDirection: 'asc' | 'desc' = 'asc';
  openAC!: CommercialAgreement;
  business: string = '';
  commercialAgreementsStatuces = appConstants.ACstatus;
  uploadModalType: 'readjustment' | 'create' | null = null;
  constructor(
    private offcanvasService: NgbOffcanvas,
    private modalsService: ModalsService,
    private commercialAgreementsService: CommercialAgreementsService,
    private masterService: MasterService,
    private fb: FormBuilder,
    private usersService: UsersService,
    private currencyPipe: CurrencyPipe,
    private feedbacksService: FeedbacksService,
    private apiService: ApiRequestsService
  ) {
    this.dtOptions = appConstants.datatables.options;
    this.commercialFormGroup = this.fb.group({
      commercialAgreementsForm: this.fb.array([]),
    });
    this.filterForm = this.fb.group({
      dateRange: [''],
      plate: this.fb.control<string>(''),
      carrier: [''],
      center: [''],
      status: [''],
      sapID: [''],
    });
  }

  ngOnInit(): void {
    this.isGettingAgreements = true;
    this.master = this.masterService.getMaster();
    this.masterDisplayMap = this.masterService.getMasterDisplayMap();
    this.CENTERS = this.master['CENTERS'];
    this.STATUSES = this.master['COMMERCIALAGREEMENT#STATUSES'];
    this.CARRIERS = this.master['CARRIERS'];
    this.CARRIERSINDEX = this.masterDisplayMap['CARRIERS'];
    this.business = this.usersService.business.value;
    this.getCommercialAgreements();
  }

  open(content: any, AC: CommercialAgreement) {
    this.openAC = AC;
    this.historyFormatArray = [];
    this.offcanvasRef = this.offcanvasService.open(content, {
      position: 'start',
      backdrop: true,
    });
    this.offCanvasAc = AC;
    AC.history.forEach((history) => {
      if (history) {
        this.historyFormatArray.push(JSON.parse(history));
      }
    });
  }

  close() {
    this.offcanvasRef?.close();
  }

  async getCommercialAgreements() {
    this.isGettingAgreements = true;
    this.commercialAgreements =
      await this.commercialAgreementsService.getCommercialAgreementList(
        this.business
      );
    this.populateForm(this.commercialAgreements);
  }

  get acControls(): FormArray {
    return this.commercialFormGroup.get(
      'commercialAgreementsForm'
    ) as FormArray;
  }

  selectAll(event: any) {
    this.isGettingAgreements = true;
    let selected = event.target.checked;
    this.acControls.controls.forEach((acControl) => {
      acControl.get('selected')?.setValue(selected);
    });
    this.isGettingAgreements = false;
  }

  async showUploadModal(type: 'readjustment' | 'create') {
    this.uploadModalType = type;
    await this.modalsService.showModal(
      <TemplateRef<any>>this.uploadModal,
      false,
      'lg'
    );
  }

  populateForm(commercialAgreements: CommercialAgreement[]): void {
    this.commercialFormGroup = this.fb.group({
      commercialAgreementsForm: this.fb.array([]),
    });
    commercialAgreements.forEach((element) => {
      this.acControls.push(this.fb.group({ selected: false, AC: element }));
    });
    this.paginate();
    this.total = this.acControls.length;
    this.isGettingAgreements = false;
  }

  onSort(column: string): void {
    if (this.sortColumn === column) {
      // Alternar entre ascendente y descendente
      this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
    } else {
      // Nuevo campo de ordenamiento
      this.sortColumn = column;
      this.sortDirection = 'asc';
    }
    this.sortData();
    this.paginate();
  }

  sortData(): void {
    const direction = this.sortDirection === 'asc' ? 1 : -1;
    this.acControls.controls.sort((a, b) => {
      const valA = a.value.AC[this.sortColumn];
      const valB = b.value.AC[this.sortColumn];
      if (valA == null) return -1 * direction;
      if (valB == null) return 1 * direction;
      // Si son fechas, convierte para comparar
      if (valA instanceof Date || Date.parse(valA)) {
        return (
          (new Date(valA).getTime() - new Date(valB).getTime()) * direction
        );
      }
      let result = 0;
      if (valA < valB) {
        result = -1;
      } else if (valA > valB) {
        result = 1;
      }
      return result * direction;
    });
  }

  paginate() {
    let startIndex = (this.page - 1) * this.pageSize;
    let endIndex = Math.min(startIndex + this.pageSize, this.acControls.length);
    this.ACToView = this.acControls.controls.slice(startIndex, endIndex);
    this.firstItemIndex = startIndex + 1;
    this.lastItemIndex = endIndex;
  }

  async showCreateModal(fromExisting?: boolean) {
    if (fromExisting) {
      let selectedAC: CommercialAgreement = this.getSelectedAgreements()[0];
      this.fromExistingAc = selectedAC;
    }
    await this.modalsService
      .showModal(<TemplateRef<any>>this.createModal)
      .then((result) => {
        this.fromExistingAc = undefined;
        if (result) {
          this.feedbacksService.showFeedback(
            `Acuerdo Commercial Creado Correctamente.`,
            'success'
          );
          this.getCommercialAgreements();
        }
      });
  }

  async showUpdateListModal(action: 'reject' | 'aprove' | 'cancel') {
    if (!this.isButtonActive(action)) {
      return;
    }
    switch (action) {
      case 'reject':
        this.action = 'reject';
        break;
      case 'cancel':
        if (
          !this.validateSelectedAgreementsStatus(
            this.commercialAgreementsStatuces.cancel
          )
        ) {
          this.action = 'cancel';
        }
        break;
      case 'aprove':
        if (
          this.validateSelectedAgreementsStatus(
            this.commercialAgreementsStatuces.pendingN1
          )
        ) {
          this.action = 'aproveN1';
        } else if (
          this.validateSelectedAgreementsStatus(
            this.commercialAgreementsStatuces.pendingN2
          )
        ) {
          this.action = 'aproveN2';
        }
        break;
    }
    this.selectedAgreements = this.getSelectedAgreements();
    await this.modalsService
      .showModal(<TemplateRef<any>>this.updateListModal)
      .then((result) => {
        if (result) {
          this.getCommercialAgreements();
        }
      });
  }

  getSelectedAgreements(): CommercialAgreement[] {
    return this.acControls.controls
      .filter((control) => control.get('selected')?.value) //Filtra solo los seleccionados
      .map((control) => control.get('AC')?.value as CommercialAgreement); // Extrae el objeto AC
  }

  validateSelectedAgreementsStatus(expectedStatus: string): boolean {
    const selectedControls = this.acControls.controls.filter(
      (control) => control.get('selected')?.value
    );
    return (
      selectedControls.length > 0 &&
      selectedControls.every(
        (control) =>
          control.get('AC')?.value?.status ===
          this.business.toUpperCase() + expectedStatus
      )
    );
  }

  isButtonActive(button: string): boolean {
    const hasStatus = (status: string) =>
      this.validateSelectedAgreementsStatus(status);
    const isN1 = this.usersService.isAcN1;
    const isN2 = this.usersService.isAcN2;
    const isCreator = this.usersService.isAcCreator;
    const selected = this.getSelectedAgreements();

    switch (button) {
      case 'aprove':
      case 'reject':
        return (
          (hasStatus(this.commercialAgreementsStatuces.pendingN1) && isN1) ||
          (hasStatus(this.commercialAgreementsStatuces.pendingN2) && isN2)
        );

      case 'create':
        return isCreator || isN1;

      case 'createExisting':
        return selected.length === 1 && (isCreator || isN1);

      case 'cancel':
        return (
          !hasStatus(this.commercialAgreementsStatuces.cancel) &&
          selected.length > 0
        );
      case 'excel':
        return (
          this.filterForm.value.dateRange &&
          this.filterForm.get('dateRange')?.touched
        );
      default:
        return false;
    }
  }

  isActiveUpload(): boolean {
    let isActive = false;
    if (this.usersService.isAcN1 || this.usersService.isAcCreator) {
      isActive = true;
    }
    return isActive;
  }
  isActiveReadjustment() {
    return this.usersService.isAcCreator;
  }

  cleanFilters() {
    this.getCommercialAgreements();
    this.filterForm = this.fb.group({
      dateRange: [''],
      plate: this.fb.control<string>(''),
      carrier: [''],
      center: [''],
      status: [''],
      sapID: [''],
    });
  }

  async onFilter() {
    this.isGettingAgreements = true;
    this.commercialAgreements =
      await this.commercialAgreementsService.getCommercialAgreementList(
        this.business
      );
    let filteredAC: CommercialAgreement[] = this.commercialAgreements;
    this.isGettingAgreements = true;
    this.commercialFormGroup = this.fb.group({
      commercialAgreementsForm: this.fb.array([]),
    });
    const selectedMonth = this.filterForm.value.dateRange;
    if (
      this.filterForm.value.dateRange &&
      this.filterForm.get('dateRange')?.touched
    ) {
      let [year, month] = selectedMonth.split('-').map(Number);
      filteredAC = filteredAC.filter((AC) => {
        let searchDate = new Date(year, month - 1, 1); // primer día del mes
        //hacer que la acStart sea el primer dia del mes y año del
        let acStart = new Date(AC.startTime);
        acStart.setUTCDate(1); // Primer día del mes
        acStart.setUTCHours(0, 0, 0, 0); //hora al inicio del día
        let acEnd = new Date(AC.endTime);
        acEnd.setUTCMonth(acEnd.getMonth() + 1); // Ir al siguiente mes
        acEnd.setUTCDate(0); // Día 0 del siguiente mes = último día del mes actual
        acEnd.setUTCHours(23, 59, 59, 999); //hora al final del día
        return acStart <= searchDate && acEnd >= searchDate;
      });
    }
    if (
      this.filterForm.value.center &&
      this.filterForm.get('center')?.touched
    ) {
      filteredAC = filteredAC.filter((AC) => {
        return AC.center === this.filterForm.value.center;
      });
    }
    if (
      this.filterForm.value.carrier &&
      this.filterForm.get('carrier')?.touched
    ) {
      filteredAC = filteredAC.filter((AC) => {
        return AC.carrier === this.filterForm.value.carrier;
      });
    }
    if (
      this.filterForm.value.status &&
      this.filterForm.get('status')?.touched
    ) {
      filteredAC = filteredAC.filter((AC) => {
        return AC.status === this.filterForm.value.status;
      });
    }
    if (this.filterForm.value.plate && this.filterForm.get('plate')?.touched) {
      filteredAC = filteredAC.filter((AC) => {
        return (
          AC.entityId.toUpperCase() ===
          String(this.filterForm.value.plate).toUpperCase()
        );
      });
    }
    if (this.filterForm.value.sapID && this.filterForm.get('sapID')?.touched) {
      filteredAC = filteredAC.filter((AC) => {
        return AC.sapId.includes(this.filterForm.value.sapID);
      });
    }
    this.populateForm(filteredAC);
  }

  downloadCommercialAgreements() {
    if (
      this.filterForm.value.dateRange &&
      this.filterForm.get('dateRange')?.touched
    ) {
      const selectedMonth = this.filterForm.value.dateRange;
      let date = selectedMonth;
      let sap_id = this.filterForm.get('sapID')?.value;
      let carrier = this.filterForm.get('carrier')?.value;
      let center = this.filterForm.get('center')?.value;
      let status = this.filterForm.get('status')?.value;
      let plate = this.filterForm.get('plate')?.value;
      let parameters: CommercialAgreementFileParams = {
        date,
        sap_id,
        carrier,
        center,
        status,
        license_plate: plate.toUpperCase(),
        business: this.business.toUpperCase(),
      };
      this.apiService.downloadExcelCommercialAgreements(parameters);
    } else {
      return;
    }
  }

  getFormattedAmount(value: number, currency: string): string {
    if (currency === 'USD' || currency === 'CLP') {
      const amount = this.currencyPipe.transform(
        value,
        currency,
        'symbol-narrow',
        '1.0-2',
        'es-CL'
      );
      return `${amount} - ${currency}`;
    }
    return '';
  }
}
